<!-- <jhi-loader></jhi-loader> -->
<app-topnav></app-topnav>
@if (routeNone()) {
  <div>
    @if (showNav) {
      <app-nav-bar-home [navType]="type"></app-nav-bar-home>
    }
    <router-outlet></router-outlet>
    @if (!cookieConsent) {
      <div class="cookie-consent">
        <div class="d-flex">
          <span>Este site utiliza cookies para uma melhor experiência de usuário. <a routerLink="/politica" style="text-decoration: underline;"> Saiba mais </a> </span>
          <div class="mt-2 d-flex align-items-center justify-content-center g-2">
            <button class="btn btn-success mr-1" (click)="onCookieConsent()">Entendi</button>
            <!-- <button class="allow-button">Cancelar</button> -->
          </div>
        </div>
      </div>
    }
  </div>
}
<app-footer-menu [containsFooter]="containsFooter"></app-footer-menu>
